// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__abZ3H","title":"ClientInsurance_title__LoVB8","itemText":"ClientInsurance_itemText__iJBVg"};